import { Slide } from 'react-awesome-reveal';

import { uid } from 'uid';

import skillList, { educationData, resumeData } from '../data/resume';

const Skills = () => (
  <Slide direction="left">
    <div className="w-screen h-screen relative z-50 pl-20 pr-36 py-20 page-layout-responsive">
      <div className="bg-slate-50 dark:bg-slate-800 w-full h-full rounded-xl p-10  overflow-y-scroll">
        <div className="mb-5">
          <p className="text-slate-500 text-lg text-center">Check out my Resume</p>
          <h1 className="text-black dark:text-white font-bold text-center text-5xl my-3">
            My
            <span className="colored-main-left">Resume</span>
          </h1>
          <div className="animated-bar" />
        </div>
        <div className="w-full resume-small-screen">
          <h3 className="mb-6 font-semibold text-left text-4xl test-dark dark:text-white">Experience</h3>
          <div className="grid grid-cols-2 gap-5 resume-section">
            {resumeData.map((item) => (
              <div className="resume-item" key={uid()}>
                <span className="item-arrow" />
                <h5 className="main-color-esperience">{item.title}</h5>
                <p className="text-1xl my-2 dark:text-white text-black">
                  {item.company}
                  {' '}
                  /
                  {item.date}
                </p>
                <p className="mb-5 text-base text-gray-500 sm:text-md dark:text-gray-400">
                  {item.description ? (
                    item.description
                  ) : (
                    <>
                      My new responsibilities in this role are:
                      <ul className="responsabilities">
                        {item.responsibilities.map((task) => (
                          <li key={uid()}>{task}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </p>
              </div>
            ))}
          </div>
        </div>
        <hr className="separator-hr" />
        <div className="w-full resume-small-screen">
          <h3 className="mb-6 font-semibold text-left text-4xl test-dark dark:text-white">Eduction</h3>
          <div className="grid grid-cols-2 gap-5 resume-section">
            {educationData.map((item) => (
              <div className="resume-item" key={uid()}>
                <span className="item-arrow" />
                <h5 className="main-color-esperience">{item.title}</h5>
                <p className="text-1xl my-2 dark:text-white text-black">
                  {item.institution}
                  {' '}
                  /
                  {item.date}
                </p>
                <p className="mb-5 text-base text-gray-500 sm:text-md dark:text-gray-400">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        <hr className="separator-hr" />
        <div className="w-full resume-small-screen">
          <h3 className="mb-6 font-semibold text-left text-4xl test-dark dark:text-white">Skills</h3>
          {Object.keys(skillList).map((key) => (
            <>
              <h4 className="text-2xl font-semibold text-left text-black dark:text-white mb-5" key={uid()}>
                {key.replace(/_/g, ' ')}
              </h4>
              <div className="grid gap-4 grid-cols-4 justify-start resume-section skills" key={uid()}>
                {skillList[key].map((skill) => (
                  <div className="resume-item" key={uid()}>
                    <span className="item-arrow" />
                    <h5 className="flex items-center main-color-esperience">
                      {skill.icon}
                      {' '}
                      {skill.name}
                    </h5>
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  </Slide>
);

export default Skills;
